// extracted by mini-css-extract-plugin
export var chip = "_r1-2";
export var chipBody = "_r1-8";
export var chipHeader = "_r1-9";
export var chipWithKind = "_r1-7";
export var icon = "_r1-3";
export var kind = "_r1-a";
export var remove = "_r1-5";
export var removeIcon = "_r1-6";
export var row = "_r1-0";
export var rowHistorical = "_r1-1";
export var text = "_r1-4";